import React, { useEffect, useRef, useState, version } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import OperationResult from "../commons/OperationResult";
import { Box, Typography, FormControlLabel, Switch } from "@mui/material";
import ExtraMediaCard from "./ExtraMediaCard";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { postData, postFormData } from "../api/AuthenticatedApiCaller";
import { ExtrasApi } from "../api/AdminApi";
import VehicleMediaCard from "../commons/VehicleMediaCard";

export function ExtrasAddDialog(props) {
  const [hasError, setHasError] = useState(null);
  const [image, setImage] = useState(null);

  const updatedExtra =
    props.extra !== null
      ? JSON.parse(JSON.stringify(props.extra))
      : {
          title: "",
          pricePerDay: 0,
          active: false,
          imageUrl: "",
          replaceImage: false,
        };

  async function save() {
    updatedExtra.replaceImage = image === null ? false : true;
    let formData = new FormData();
    let jsonAsBlob =  new Blob([JSON.stringify(updatedExtra)], {
      type: "application/json",
    });

    formData.append("extra", jsonAsBlob);
    formData.append("image", image);

    let [data, error] = await postFormData(ExtrasApi.set, formData);
    if (!error) {
      setHasError(false);
    } else {
      setHasError(true);
    }
    props.save();
  }

  const addImage = (e) => {
    console.log(e);
    setImage(e);
    updatedExtra.replaceImage = true;
    //setImg(e.target.files[0]);
  };

  return (
    <Box>
      <Dialog fullWidth={true} open={props.open} onClose={props.close}>
        <DialogTitle id="alert-dialog-title">Create a new Extra</DialogTitle>

        <DialogContent>
          <Stack spacing={0.8}>
            <TextField
              label="Title"
              defaultValue={updatedExtra.title}
              onChange={(event) => {
                updatedExtra.title = event.target.value;
              }}
              required
            />
            <TextField
              label="Price Per Day"
              defaultValue={updatedExtra.pricePerDay}
              onChange={(event) => {
                updatedExtra.pricePerDay = event.target.value;
              }}
              required
            />
            <VehicleMediaCard
              imageUrl={updatedExtra.imageUrl}
              callback={addImage}
            />

            {/* <ExtraMediaCard
              src={props.extra !== null ? props.extra["imageUrl"] : null}
              addImageCallback={(fileImage) => {
                image = fileImage;
              }}
            /> */}
          </Stack>
          <DialogActions>
            <Button onClick={save}>Save</Button>
            <Button onClick={props.cancel} autoFocus>
              Cancel
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
